/** @jsxImportSource @emotion/react */
import { Grid, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
import { GtHidden } from '../temp-custom-ui-components';

interface IProps {
  title: string;
  value: string;
  subTitle?: string;
  subValue?: string;
  subSubTitle?: string;
  subSubValue?: string;
}

export function SummaryStatisticItem({
  title,
  value,
  subTitle,
  subValue,
  subSubTitle,
  subSubValue,
}: IProps): ReactElement {
  return (
    <Grid className="stat-cell" item md={3} sm={6} xs={12}>
      <GtHidden xsDown>
        <table>
          <tbody>
            <tr>
              <td>
                <Typography variant="h6">{title}</Typography>
              </td>
              {subTitle && (
                <td>
                  <Typography
                    variant="h6"
                    color="textSecondary"
                    style={{ marginLeft: '5px' }}
                  >
                    ({subTitle})
                  </Typography>
                </td>
              )}
              {subSubTitle && (
                <td>
                  <Typography
                    variant="h6"
                    color="textSecondary"
                    style={{ marginLeft: '5px' }}
                  >
                    ({subSubTitle})
                  </Typography>
                </td>
              )}
            </tr>

            <tr>
              <td>
                <Typography variant="h6">{value}</Typography>
              </td>
              {subValue && (
                <td>
                  <Typography
                    variant="h6"
                    color="textSecondary"
                    style={{ marginLeft: '5px' }}
                  >
                    ({subValue})
                  </Typography>
                </td>
              )}
              {subSubValue && (
                <td>
                  <Typography
                    variant="h6"
                    color="textSecondary"
                    style={{ marginLeft: '5px' }}
                  >
                    ({subSubValue})
                  </Typography>
                </td>
              )}
            </tr>
          </tbody>
        </table>
      </GtHidden>

      <GtHidden xsUp>
        <div>
          <Typography style={{ marginRight: '5px' }} variant="h6">
            {title}
          </Typography>
          {subTitle && (
            <Typography variant="h6" color="textSecondary">
              ({subTitle})
            </Typography>
          )}
          {subSubTitle && (
            <Typography variant="h6" color="textSecondary">
              ({subSubTitle})
            </Typography>
          )}
        </div>
        <GtHidden smUp>
          <Typography variant="h6">&nbsp;-&nbsp;</Typography>
        </GtHidden>
        <div style={{ marginLeft: '5px' }}>
          <Typography variant="h5">{value}</Typography>
          {subValue && (
            <Typography variant="h6" color="textSecondary">
              ({subValue})
            </Typography>
          )}
          {subSubValue && (
            <Typography variant="h6" color="textSecondary">
              ({subSubValue})
            </Typography>
          )}
        </div>
      </GtHidden>
    </Grid>
  );
}
